import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

import './Contact.css';

const Contact = () => {
    
    const form = useRef();

    const [submitted, setSubmitted] = useState(false);
    const [success, setSuccess] = useState(null);
    const [filled, setFilled] = useState(false);

    const handleSubmitted = (submitted) => {
        if(!submitted) {
            setSubmitted(!submitted);
        }
    };

    const handleSuccess = (newSuccess) => {
        setSuccess(newSuccess);
    };

    const sendEmail = (e) => {

        setSuccess(false);      
        e.preventDefault();

        const empName = document.forms["form"]["user_name"].value;
        const empEmail = document.forms["form"]["user_email"].value;
        const empMessage = document.forms["form"]["message"].value;

        if (empName && empEmail && empMessage) {
            setFilled(true);
        }

        handleSubmitted(submitted);
        
        if (filled) {

            handleSubmitted(submitted);
    
            emailjs.sendForm('service_cm2uz9c', 'template_lcmffj9', form.current, 'FKC373I6g-JjuTk3R')
                .then(() => {
                    handleSuccess(true);            
                }, (error) => {
                    console.log(error.text);
            });
        }

        else if (!filled) {
            handleSuccess(false);
        }

    };

    const renderStatus = () => {
        
        if (!submitted) {
            return (null);
        }

        else if (success && submitted) {
            return (
                <p className="success">
                    Message Sent!
                </p>
            );
        }

        else if (!success && submitted && !filled) {
            return (
                <p className="error">
                    Error! Make sure all fields are filled!
                </p>
            );
        }

    };

    return (
        <article id="Contact" className="contact">
            <h2>Contact</h2>

            <form name = "form" ref={form} onSubmit={sendEmail}>
                <label htmlFor="name">Your Name</label>
                <input type="text" name="user_name" id="name" placeholder = "Your Name" autoComplete="off" />

                <label htmlFor="email">Your Email</label>
                <input type="text" name="user_email" id="email" placeholder = "Your Email" autoComplete="off" />

                <label htmlFor="message">Your Message</label>
                <textarea rows="5" name="message" id="message" placeholder = "Your Message" autoComplete="off" />

                <button type="submit" value="Send">
                    Submit
                </button>
            </form>

            {renderStatus()}
        </article>
    );
};


export default Contact;